import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'application-lottery'
const initialState = {
    list: null,
    loading: false,
}
export const search = createApiAction('application-lottery/get', client.retrieve('/api/application/lottery/download/:schoolId'))
export const save = createApiAction('application-lottery/save', client.save('/api/application/lottery/upload/:fileURL'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
        .addCase(search.pending, (state) => {
            state.loading = true
        })
        .addCase(search.fulfilled, (state, action) => {
            state.list = action.payload
            state.loading = false
        })
        .addCase(search.rejected, (state) => {
            state.loading = false
        })
  },
})

export default sessionSlice.reducer
